import { defineMessages } from 'react-intl';

export default defineMessages({

  relationshipToYou: {
    id: 'fastCover.petMedicalStep.relationshipToYou',
    defaultMessage: "Claimant's Relationship to you",
  },

  nationalIdOrVisa: {
    id: 'fastCover.petMedicalStep.nationalIdOrVisa',
    defaultMessage: 'National ID or Visa #',
  },

  ifYesPleaseProvide: {
    id: 'fastCover.petMedicalStep.ifYesPleaseProvide',
    defaultMessage: "If yes, please provide the carrier's name, address and policy insurance:",
  },

  nationalId: {
    id: 'fastCover.petMedicalStep.nationalId',
    defaultMessage: 'National ID',
  },

  visa: {
    id: 'fastCover.petMedicalStep.visa',
    defaultMessage: 'Visa #',
  },

  id: {
    id: 'fastCover.petMedicalStep.id',
    defaultMessage: 'ID #',
  },

  purposeOfTrip: {
    id: 'fastCover.petMedicalStep.purposeOfTrip',
    defaultMessage: 'Purpose of Trip',
  },

  holiday: {
    id: 'fastCover.petMedicalStep.holiday',
    defaultMessage: 'Holiday',
  },

  business: {
    id: 'fastCover.petMedicalStep.business',
    defaultMessage: 'Business',
  },

  medical: {
    id: 'fastCover.petMedicalStep.medical',
    defaultMessage: 'Medical',
  },

  other: {
    id: 'fastCover.petMedicalStep.other',
    defaultMessage: 'Other',
  },

  ifOtherPleaseDescribe: {
    id: 'fastCover.petMedicalStep.ifOtherPleaseDescribe',
    defaultMessage: 'If other, please describe',
  },

  didYouContactAssistanceCompany: {
    id: 'fastCover.petMedicalStep.didYouContactAssistanceCompany',
    defaultMessage: 'Did you contact our Assistance Company?',
  },

  assistanceCaseReferenceNumberFileNumber: {
    id: 'fastCover.petMedicalStep.assistanceCaseReferenceNumberFileNumber',
    defaultMessage: 'Assistance Case Reference Number / File Number',
  },

  doYouHaveOtherTypeOfPetInsurance: {
    id: 'fastCover.petMedicalStep.doYouHaveOtherTypeOfPetInsurance',
    defaultMessage: 'Do you have any other type of pet travel insurance?',
  },

  companyName: {
    id: 'fastCover.petMedicalStep.companyName',
    defaultMessage: 'Company Name',
  },

  address: {
    id: 'fastCover.petMedicalStep.address',
    defaultMessage: 'Address',
  },

  cityOrTown: {
    id: 'fastCover.petMedicalStep.cityOrTown',
    defaultMessage: 'City or Town',
  },

  country: {
    id: 'fastCover.petMedicalStep.country',
    defaultMessage: 'Country',
  },

  postalCode: {
    id: 'fastCover.petMedicalStep.postalCode',
    defaultMessage: 'Postal Code',
  },

  policyId: {
    id: 'fastCover.petMedicalStep.policyId',
    defaultMessage: 'Policy ID',
  },

  contact: {
    id: 'fastCover.petMedicalStep.contact',
    defaultMessage: 'Contact',
  },

  email: {
    id: 'fastCover.petMedicalStep.email',
    defaultMessage: 'Email',
  },

  phoneNumber: {
    id: 'fastCover.petMedicalStep.phoneNumber',
    defaultMessage: 'Phone Number',
  },

  areYouACitizenOfTheEuropeanUnion: {
    id: 'fastCover.petMedicalStep.areYouACitizenOfTheEuropeanUnion',
    defaultMessage: 'Are you a citizen of the European Union?',
  },

  forEUCitizens: {
    id: 'fastCover.petMedicalStep.forEUCitizens',
    defaultMessage: 'Was a European Health Insurance Card (EHIC) taken on this trip?',
  },

  ifYesWasTheEHIC: {
    id: 'fastCover.petMedicalStep.ifYesWasTheEHIC',
    defaultMessage: 'If yes, was the EHIC presented to the hospital or physician?',
  },

  petIllnessOrAccidentStatement: {
    id: 'fastCover.petMedicalStep.petIllnessOrAccidentStatement',
    defaultMessage: 'PET - ILLNESS/ACCIDENT STATEMENT',
  },

  accidentStartDate: {
    id: 'fastCover.petMedicalStep.accidentStartDate',
    defaultMessage: 'Accident/Illness Start Date',
  },

  accidentStartDateForIllness: {
    id: 'fastCover.petMedicalStep.accidentStartDate',
    defaultMessage: 'Illness Start Date',
  },

  accidentFirstTreatment: {
    id: 'fastCover.petMedicalStep.accidentFirstTreatment',
    defaultMessage: 'Accident/Illness First Treatment',
  },

  nameOfPhysicianFacilityFirstContacted: {
    id: 'fastCover.petMedicalStep.nameOfPhysicianFacilityFirstContacted',
    defaultMessage: 'Name of Physician/Facility first contacted',
  },

  ifNoPleaseExplain: {
    id: 'fastCover.petMedicalStep.ifNoPleaseExplain',
    defaultMessage: 'If no, please explain',
  },

  isTheClaimTheResultOfAniLLness: {
    id: 'fastCover.petMedicalStep.isTheClaimTheResultOfAnIllness',
    defaultMessage: 'Is the claim the result of an Illness?',
  },

  symptoms: {
    id: 'fastCover.petMedicalStep.symptoms',
    defaultMessage: 'Symptoms',
  },

  details: {
    id: 'fastCover.petMedicalStep.details',
    defaultMessage: 'Details',
  },

  isTheClaimTheResultOfAccidentOrInjury: {
    id: 'fastCover.petMedicalStep.isTheClaimTheResultOfAccidentOrInjury',
    defaultMessage: 'Is the claim the result of accident or injury?',
  },

  place: {
    id: 'fastCover.petMedicalStep.place',
    defaultMessage: 'Place',
  },

  accidentDate: {
    id: 'fastCover.petMedicalStep.accidentDate',
    defaultMessage: 'Accident Date',
  },

  accidentTime: {
    id: 'fastCover.petMedicalStep.accidentTime',
    defaultMessage: 'Accident Time',
  },

  wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity: {
    id: 'fastCover.petMedicalStep.wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity',
    defaultMessage: 'Was the accident or injury the result of playing a sport or due to a hazardous activity?',
  },

  treatingPhysicianFacility: {
    id: 'fastCover.petMedicalStep.treatingPhysicianFacility',
    defaultMessage: 'Treating Physician/Facility',
  },

  treatingPhysicianFacilityFirstContacted: {
    id: 'fastCover.petMedicalStep.treatingPhysicianFacility',
    defaultMessage: 'Treating Physician/Facility',
  },

  ifPriorTreatmentWasGivenIn: {
    id: 'fastCover.petMedicalStep.ifPriorTreatmentWasGivenIn',
    defaultMessage: 'If prior treatment was given in a hospital, as an inpatient, please provide',
  },

  facilityName: {
    id: 'fastCover.petMedicalStep.facilityName',
    defaultMessage: 'Facility Name',
  },

  admitDate: {
    id: 'fastCover.petMedicalStep.admitDate',
    defaultMessage: 'Admit Date',
  },

  timeOfAdmission: {
    id: 'fastCover.petMedicalStep.timeOfAdmission',
    defaultMessage: 'Time of Admission',
  },

  dischargeDate: {
    id: 'fastCover.petMedicalStep.dischargeDate',
    defaultMessage: 'Discharge Date',
  },

  timeOfDischarge: {
    id: 'fastCover.petMedicalStep.timeOfDischarge',
    defaultMessage: 'Time of Discharge',
  },

  expensesClaimed: {
    id: 'fastCover.petMedicalStep.expensesClaimed',
    defaultMessage: 'Expenses Claimed',
  },

  currency: {
    id: 'fastCover.petMedicalStep.currency',
    defaultMessage: 'Currency',
  },

  didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness: {
    id: 'fastCover.petMedicalStep.didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness',
    defaultMessage: 'Did any physician prohibit you from traveling by air or otherwise due to this injury/Illness?',
  },

  wereYouTravelingToReceiveMedicalTreatment: {
    id: 'fastCover.petMedicalStep.wereYouTravelingToReceiveMedicalTreatment',
    defaultMessage: 'Were you traveling to receive medical treatment?',
  },

  alternativeTreatment: {
    id: 'fastCover.petMedicalStep.alternativeTreatment',
    defaultMessage: 'Alternative Treatment',
  },

  ifYesWhenDidYouLearnOfTheAlternativeTreatment: {
    id: 'fastCover.petMedicalStep.ifYesWhenDidYouLearnOfTheAlternativeTreatment',
    defaultMessage: 'If yes, when did you learn of the alternative treatment?',
  },

  whoRecommendedTheTreatment: {
    id: 'fastCover.petMedicalStep.whoRecommendedTheTreatment',
    defaultMessage: 'Who recommended the treatment?',
  },

  areYouPregnant: {
    id: 'fastCover.petMedicalStep.areYouPregnant',
    defaultMessage: 'Are you pregnant?',
  },

  ifYesNumberOfWeeks: {
    id: 'fastCover.petMedicalStep.ifYesNumberOfWeeks',
    defaultMessage: 'If yes, number of weeks',
  },

  yes: {
    id: 'fastCover.petMedicalStep.yes',
    defaultMessage: 'Yes',
  },

  no: {
    id: 'fastCover.petMedicalStep.no',
    defaultMessage: 'No',
  },
  //---------------------------
  areYouClaimingForDamagedLostOrStolenLuggage: {
    id: 'fastCover.stepBaggageAndPersonalItems.areYouClaimingForDamagedLostOrStolenLuggage',
    defaultMessage: 'Are you claiming for Damaged, Lost, or Stolen Luggage?',
  },

  areYouClaimingForBaggageDelay: {
    id: 'fastCover.stepBaggageAndPersonalItems.areYouClaimingForBaggageDelay',
    defaultMessage: 'Are you claiming for Baggage Delay?',
  },

  areYouClaimingFor: {
    id: 'fastCover.stepBaggageAndPersonalItems.areYouClaimingFor',
    defaultMessage: 'Are you claiming for:',
  },

  travelSupplierProviderInformation: {
    id: 'fastCover.stepBaggageAndPersonalItems.travelSupplierProviderInformation',
    defaultMessage: 'Travel Supplier / Provider Information',
  },

  companyYouWereTravelingWith: {
    id: 'fastCover.stepBaggageAndPersonalItems.companyYouWereTravelingWith',
    defaultMessage: 'Company you were traveling with:',
  },

  origin: {
    id: 'fastCover.stepBaggageAndPersonalItems.origin',
    defaultMessage: 'Origin',
  },

  flightNumber: {
    id: 'fastCover.stepBaggageAndPersonalItems.flightNumber',
    defaultMessage: 'Flight Number',
  },

  airCarrier: {
    id: 'fastCover.stepBaggageAndPersonalItems.airCarrier',
    defaultMessage: 'Air Carrier',
  },

  destination: {
    id: 'fastCover.stepBaggageAndPersonalItems.destination',
    defaultMessage: 'Destination',
  },

  lossInformation: {
    id: 'fastCover.stepBaggageAndPersonalItems.lossInformation',
    defaultMessage: 'Loss Information',
  },

  dateOfLoss: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateOfLoss',
    defaultMessage: 'Date of Loss',
  },

  pleaseDescribeWhatOccurred: {
    id: 'fastCover.stepBaggageAndPersonalItems.pleaseDescribeWhatOccurred',
    defaultMessage: 'Please describe what occurred',
  },

  whoDidYouReportTo: {
    id: 'fastCover.stepBaggageAndPersonalItems.whoDidYouReportTo',
    defaultMessage: 'Who did you report to?',
  },

  reportReferenceNumber: {
    id: 'fastCover.stepBaggageAndPersonalItems.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },

  nameAndAddress: {
    id: 'fastCover.stepBaggageAndPersonalItems.nameAndAddress',
    defaultMessage: 'Name and Address',
  },

  nameCustomerServiceDepartment: {
    id: 'fastCover.stepBaggageAndPersonalItems.nameCustomerServiceDepartment',
    defaultMessage: 'Name (Customer Service Department)',
  },

  doYouHaveAnyFurtherDetailsToAdd: {
    id: 'fastCover.stepBaggageAndPersonalItems.doYouHaveAnyFurtherDetailsToAdd',
    defaultMessage: 'Do you have any further details to add',
  },

  loss: {
    id: 'fastCover.stepBaggageAndPersonalItems.loss',
    defaultMessage: 'Loss',
  },

  theft: {
    id: 'fastCover.stepBaggageAndPersonalItems.theft',
    defaultMessage: 'Theft',
  },

  damage: {
    id: 'fastCover.stepBaggageAndPersonalItems.damage',
    defaultMessage: 'Damage',
  },

  tourOperator: {
    id: 'fastCover.stepBaggageAndPersonalItems.tourOperator',
    defaultMessage: 'Tour Operator',
  },

  cruiseLine: {
    id: 'fastCover.stepBaggageAndPersonalItems.cruiseLine',
    defaultMessage: 'Cruise Line',
  },

  airline: {
    id: 'fastCover.stepBaggageAndPersonalItems.airline',
    defaultMessage: 'Airline',
  },

  airport: {
    id: 'fastCover.stepBaggageAndPersonalItems.airport',
    defaultMessage: 'Airport',
  },

  hotel: {
    id: 'fastCover.stepBaggageAndPersonalItems.hotel',
    defaultMessage: 'Hotel',
  },

  rentalAgency: {
    id: 'fastCover.stepBaggageAndPersonalItems.rentalAgency',
    defaultMessage: 'Rental Agency',
  },

  police: {
    id: 'fastCover.stepBaggageAndPersonalItems.police',
    defaultMessage: 'Police',
  },

  hospitalManagement: {
    id: 'fastCover.stepBaggageAndPersonalItems.hospitalManagement',
    defaultMessage: 'Hospital Management',
  },

  cruiseShip: {
    id: 'fastCover.stepBaggageAndPersonalItems.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },

  tourGuide: {
    id: 'fastCover.stepBaggageAndPersonalItems.tourGuide',
    defaultMessage: 'Tour Guide',
  },

  notReported: {
    id: 'fastCover.stepBaggageAndPersonalItems.notReported',
    defaultMessage: 'Not Reported',
  },

  addItem: {
    id: 'fastCover.stepBaggageAndPersonalItems.addItem',
    defaultMessage: 'Add Expense',
  },

  itemWithIdx: {
    id: 'fastCover.stepBaggageAndPersonalItems.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },

  item: {
    id: 'fastCover.stepBaggageAndPersonalItems.item',
    defaultMessage: 'Item',
  },

  estimatedValue: {
    id: 'fastCover.stepBaggageAndPersonalItems.estimatedValue',
    defaultMessage: 'Estimated Value',
  },

  haveYouReceivedReimbursement: {
    id: 'fastCover.stepBaggageAndPersonalItems.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received Reimbursement?',
  },

  fromWhom: {
    id: 'fastCover.stepBaggageAndPersonalItems.fromWhom',
    defaultMessage: 'If so, from whom?',
  },

  howMuch: {
    id: 'fastCover.stepBaggageAndPersonalItems.howMuch',
    defaultMessage: 'How much?',
  },

  totalExpensesClaimed: {
    id: 'fastCover.stepBaggageAndPersonalItems.totalExpensesClaimed',
    defaultMessage: 'Total Expenses Claimed',
  },

  addPrescriptionMedicines: {
    id: 'fastCover.stepBaggageAndPersonalItems.addPrescriptionMedicines',
    defaultMessage: 'Add Prescription medicine',
  },

  prescriptionMedicinesV1: {
    id: 'fastCover.stepBaggageAndPersonalItems.prescriptionMedicinesV1',
    defaultMessage: 'Prescription medicines you have been prescribed for your injury or illness',
  },

  dosage: {
    id: 'fastCover.stepBaggageAndPersonalItems.dosage',
    defaultMessage: 'Dosage',
  },

  nameOfPrescribingDoctor: {
    id: 'fastCover.stepBaggageAndPersonalItems.nameOfPrescribingDoctor',
    defaultMessage: 'Name of Prescribing Doctor',
  },

  prescriptionMedicinesV2: {
    id: 'fastCover.stepBaggageAndPersonalItems.prescriptionMedicinesYouHave',
    defaultMessage: 'Prescription medicines, herbal medications or vitamins you took prior to your effective date that are not related to your injury/illness',
  },

  changeTo: {
    id: 'fastCover.stepBaggageAndPersonalItems.changeTo',
    defaultMessage: 'Is this a claim due to an unexpected recurrence or a pre-existing condition?',
  },

  ifYesNameOfPhysicianCurrentlyTreatingThis: {
    id: 'fastCover.stepBaggageAndPersonalItems.ifYesNameOfPhysicianCurrentlyTreatingThis',
    defaultMessage: 'If yes, name of physician currently treating this',
  },

  // ------------------------------------------------------------------------------------

  tripCancellation: {
    id: 'fastCover.stepBaggageAndPersonalItems.tripCancellation',
    defaultMessage: 'Are you claiming for Trip Cancellation?',
  },

  travelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItems.travelInterruption',
    defaultMessage: 'Are you claiming for Travel Interruption?',
  },

  travelDelay: {
    id: 'fastCover.stepBaggageAndPersonalItems.travelDelay',
    defaultMessage: 'Are you claiming for Travel Delay?',
  },

  reasonsForTripInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasonsForTripInterruption',
    defaultMessage: 'Reasons for Trip Interruption',
  },

  reasons1: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasons1',
    defaultMessage: 'Death of an Immediate Family Member',
  },

  reasons2: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasons2',
    defaultMessage: 'You Unforeseen Sickness or Injury or, the Sickness or Injury if a Traveling Companion or Immediate Family Member',
  },

  reasons3: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasons3',
    defaultMessage: 'Substantial destruction of your principal residence by fire or weather-related activity a Medically Necessary covered Emergency Medical Evacuation to return to Your Home Country',
  },

  reasons4: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasons4',
    defaultMessage: 'or to the area from which You were initially evacuated for continued treatment, recuperation, and recovery',
  },

  travelSupplier: {
    id: 'fastCover.stepBaggageAndPersonalItems.travelSupplier',
    defaultMessage: 'Travel Supplier / Provider Information',
  },

  addressTravelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItems.addressTravelInterruption',
    defaultMessage: 'Address',
  },

  cityTravelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItems.cityTravelInterruption',
    defaultMessage: 'City',
  },

  stateTravelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItems.stateTravelInterruption',
    defaultMessage: 'State',
  },

  zipCodeTravelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItems.zipCodeTravelInterruption',
    defaultMessage: 'Zip code',
  },

  contactTravelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItems.contactTravelInterruption',
    defaultMessage: 'Contact',
  },

  includedInPackage: {
    id: 'fastCover.stepBaggageAndPersonalItems.includedInPackage',
    defaultMessage: 'If not included in package, how was air travel arranged?',
  },

  addLossInformation: {
    id: 'fastCover.stepBaggageAndPersonalItems.addLossInformation',
    defaultMessage: 'Add Loss Information',
  },

  dateTripInterrupted: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateTripInterrupted',
    defaultMessage: 'Date Trip was Interrupted',
  },

  lossInformationWithIdx: {
    id: 'fastCover.stepBaggageAndPersonalItems.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },

  reasonForInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasonForInterruption',
    defaultMessage: 'Reason for interruption',
  },

  nameOfPersonHavingSickness: {
    id: 'fastCover.stepBaggageAndPersonalItems.nameOfPersonHavingSickness',
    defaultMessage: 'Name of person having sickness of injury',
  },

  dateOfBirth: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateOfBirth',
    defaultMessage: 'His/Her date of birth',
  },

  relationshipToClaimant: {
    id: 'fastCover.stepBaggageAndPersonalItems.relationshipToClaimant',
    defaultMessage: 'His/Her relationship to claimant',
  },

  dateEnded: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateEnded',
    defaultMessage: 'Date ended',
  },

  natureOfSicknessOrInjury: {
    id: 'fastCover.stepBaggageAndPersonalItems.natureOfSicknessOrInjury',
    defaultMessage: 'Nature of Sickness or Injury (If Injury, describe accident, including date and place):',
  },

  periodOfHospitalization: {
    id: 'fastCover.stepBaggageAndPersonalItems.periodOfHospitalization',
    defaultMessage: 'Period of hospitalization (If applicable):',
  },

  companyNameLoss: {
    id: 'fastCover.stepBaggageAndPersonalItems.companyNameLoss',
    defaultMessage: 'Company name (airline/hotel/cruse/travel agent/ect.)',
  },

  amountPaidLoss: {
    id: 'fastCover.stepBaggageAndPersonalItems.amountPaidLoss',
    defaultMessage: 'Amount Paid',
  },

  amountOfLoss: {
    id: 'fastCover.stepBaggageAndPersonalItems.amountOfLoss',
    defaultMessage: 'Amount of Loss (non-refundable amount)',
  },

  howMuchReceivedReimbursement: {
    id: 'fastCover.stepBaggageAndPersonalItems.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },

  reasonsForDelay: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasonsForDelay',
    defaultMessage: 'Reasons for Delay',
  },

  reasons1ForTravelDelay: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasons1ForTravelDelay',
    defaultMessage: 'Delay of a Common Carrier (including Inclement Weather)',
  },

  reasons2ForTravelDelay: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasons2ForTravelDelay',
    defaultMessage: 'Delay by a traffic Accident en router to a departure, in which You or Your Traveling Companion is not directly involved',
  },

  reasons3ForTravelDelay: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasons3ForTravelDelay',
    defaultMessage: 'Delay due to lost or stolen passport, travel documents or money, Quarantine, hijacking, unannounced Strike, Natural Disaster, civil commotion, or riot',
  },

  reasons4ForTravelDelay: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasons4ForTravelDelay',
    defaultMessage: 'A closed roadway causing cessation of travel to the destination of the Trip (substantiated by the department of transportation, state police, etc.)',
  },

  dateYouWereDueToDepart: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateYouWereDueToDepart',
    defaultMessage: 'Date you were due to depart',
  },

  timeYouWereDueToDepart: {
    id: 'fastCover.stepBaggageAndPersonalItems.timeYouWereDueToDepart',
    defaultMessage: 'Time you were due to depart',
  },

  dateTripWasDelayed: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateTripWasDelayed',
    defaultMessage: 'Date trip was delayed with Travel Supplier',
  },

  dateDelayEnded: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateDelayEnded',
    defaultMessage: 'Date delay ended',
  },

  dateYouActuallyDeparted: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateYouActuallyDeparted',
    defaultMessage: 'Date you actually departed',
  },

  timeYouActuallyDeparted: {
    id: 'fastCover.stepBaggageAndPersonalItems.timeYouActuallyDeparted',
    defaultMessage: 'Time you actually departed',
  },

  delayInformation: {
    id: 'fastCover.stepBaggageAndPersonalItems.delayInformation',
    defaultMessage: 'Delay Information',
  },

  addDelayInformation: {
    id: 'fastCover.stepBaggageAndPersonalItems.addDelayInformation',
    defaultMessage: 'Add Delay Information',
  },

  delayInformationWithIdx: {
    id: 'fastCover.stepBaggageAndPersonalItems.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },

  //-----------------------------------------------------------------------------------------

  howItHappened: {
    id: 'fastCover.stepBaggageAndPersonalItems.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.stepBaggageAndPersonalItems.whereYouWereInRelationToTheItem',
    defaultMessage:
      'Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.stepBaggageAndPersonalItems.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  delay: {
    id: 'fastCover.stepBaggageAndPersonalItems.delay',
    defaultMessage: 'Delay',
  },
  hotelManagement: {
    id: 'fastCover.stepBaggageAndPersonalItems.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  otherDescription: {
    id: 'fastCover.stepBaggageAndPersonalItems.otherDescription',
    defaultMessage: 'If yes, please describe',
  },
  descriptionOfItems: {
    id: 'fastCover.stepBaggageAndPersonalItems.descriptionOfItems',
    defaultMessage: 'Description of items',
  },
  datePurchased: {
    id: 'fastCover.stepBaggageAndPersonalItems.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.stepBaggageAndPersonalItems.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.stepBaggageAndPersonalItems.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  amountClaimed: {
    id: 'fastCover.stepBaggageAndPersonalItems.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.stepBaggageAndPersonalItems.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.stepBaggageAndPersonalItems.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  additionalItem: {
    id: 'fastCover.stepBaggageAndPersonalItems.additionalItem',
    defaultMessage: 'Luggage and Personal Items',
  },
  claimed: {
    id: 'fastCover.stepBaggageAndPersonalItems.claimed',
    defaultMessage: 'Claimed',
  },
  nameOfTransportProvider: {
    id: 'fastCover.stepBaggageAndPersonalItems.nameOfTransportProvider',
    defaultMessage:
      'Name of Transport Provider (airline, cruise liner, bus etc.)',
  },
  dateWhenYourLuggageWasDelayed: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateWhenYourLuggageWasDelayed',
    defaultMessage: 'Date when your luggage was delayed',
  },
  timeWhenYourLuggageWasDelayed: {
    id: 'fastCover.stepBaggageAndPersonalItems.timeWhenYourLuggageWasDelayed',
    defaultMessage: 'Time when your luggage was delayed',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  timeWhenYourLuggageWasReturned: {
    id: 'fastCover.stepBaggageAndPersonalItems.timeWhenYourLuggageWasReturned',
    defaultMessage: 'Time when your luggage was returned',
  },
  paidForDelay: {
    id: 'fastCover.stepBaggageAndPersonalItems.paidForDelay',
    defaultMessage: 'Were you paid any compensation for this delay?',
  },
  madeClaimWithTravelProviderOrOther: {
    id: 'fastCover.stepBaggageAndPersonalItems.madeClaimWithTravelProviderOrOther',
    defaultMessage:
      'Have you made a claim with your Travel Provider (Airline, hotel, cruise liner, tour company etc.) or any other company responsible for the loss, theft, damage or delay of your luggage?',
  },
  listedOnThePolicy: {
    id: 'fastCover.stepBaggageAndPersonalItems.listedOnThePolicy',
    defaultMessage:
      'Are the luggage or personal item(s) lost, stolen, damaged or delayed owned by you or someone else listed on the policy?',
  },
  damagedLostOrStolenLuggageItems: {
    id: 'fastCover.stepBaggageAndPersonalItems.damagedLostOrStolenLuggageItems',
    defaultMessage: 'Damaged, Lost or Stolen Luggage Items',
  },
  delayedLuggageExpenses: {
    id: 'fastCover.stepBaggageAndPersonalItems.delayedLuggageExpenses',
    defaultMessage: 'Delayed Luggage Expenses',
  },
  delayedLuggageExpense: {
    id: 'fastCover.stepBaggageAndPersonalItems.delayedLuggageExpense',
    defaultMessage: 'Delayed Luggage Expense',
  },
  isRequired: {
    id: 'fastCover.stepBaggageAndPersonalItems.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  expenseTableRequired: {
    id: 'fastCover.stepBaggageAndPersonalItems.expenseTableRequired',
    defaultMessage: 'Expense table fields are mandatory fields.',
  },
  addDelayedLuggageExpense: {
    id: 'fastCover.stepBaggageAndPersonalItems.addDelayedLuggageExpense',
    defaultMessage: 'Add Delayed Luggage Expense',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.stepBaggageAndPersonalItems.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  amountOfCompensation: {
    id: 'fastCover.stepBaggageAndPersonalItems.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.stepBaggageAndPersonalItems.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.stepBaggageAndPersonalItems.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  delayedLuggageExpenseWithIdx: {
    id: 'fastCover.stepBaggageAndPersonalItems.delayedLuggageExpenseWithIdx',
    defaultMessage: 'Delayed Luggage Expense {idx}',
  },
  checkEventDate: {
    id: 'fastCover.petMedicalStep.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },

  // New Screen
  travelInformation: {
    id: 'fastCover.petMedicalStep.travelInformation',
    defaultMessage: 'Travel Information',
  },
  dateTravelArrangementsWereMade: {
    id: 'fastCover.petMedicalStep.dateTravelArrangementsWereMade',
    defaultMessage: 'Date Travel Arrangements were made',
  },
  dateOfInitialPaymentDeposit: {
    id: 'fastCover.petMedicalStep.dateOfInitialPaymentDeposit',
    defaultMessage: 'Date of initial payment deposit',
  },
  typeOfPolicy: {
    id: 'fastCover.petMedicalStep.typeOfPolicy',
    defaultMessage: 'Type Of Policy',
  },
  haveYouFiledAClaimWithTheirOfficeAtThisTime: {
    id: 'fastCover.petMedicalStep.haveYouFiledAClaimWithTheirOfficeAtThisTime',
    defaultMessage: 'Have you filed a claim with their office at this time?',
  },
  nameOfPersonHavingSicknessOrInjury: {
    id: 'fastCover.petMedicalStep.nameOfPersonHavingSicknessOrInjury',
    defaultMessage: 'Name of person having sickness or injury',
  },
  hisOrHerDateOfBirth: {
    id: 'fastCover.petMedicalStep.hisOrHerDateOfBirth',
    defaultMessage: 'His / Her date of birth',
  },
  isTheClaimTheResultOfASicknessOrInjury: {
    id: 'fastCover.petMedicalStep.isTheClaimTheResultOfASicknessOrInjury',
    defaultMessage: 'Is the claim the result of a Sickness/Injury',
  },
  natureOfSickness: {
    id: 'fastCover.medicalExpenseStfep.natureOfSickness',
    defaultMessage: 'Nature of Sickness',
  },
  accident: {
    id: 'fastCover.petMedicalStep.accident',
    defaultMessage: 'Accident',
  },
  date: {
    id: 'fastCover.petMedicalStep.date',
    defaultMessage: 'Date',
  },
  wasThereAnAccidentReportForThisIncident: {
    id: 'fastCover.petMedicalStep.wasThereAnAccidentReportForThisIncident',
    defaultMessage: 'Was there an accident report for this incident?',
  },
  sickness: {
    id: 'fastCover.petMedicalStep.sickness',
    defaultMessage: 'Sickness',
  },
  injury: {
    id: 'fastCover.petMedicalStep.injury',
    defaultMessage: 'Injury',
  },
  fromDate: {
    id: 'fastCover.petMedicalStep.fromDate',
    defaultMessage: 'From',
  },
  toDate: {
    id: 'fastCover.petMedicalStep.toDate',
    defaultMessage: 'To',
  },
  wasThereAnyPreviousTreatmentForThisCondition: {
    id: 'fastCover.petMedicalStep.wasThereAnyPreviousTreatmentForThisCondition',
    defaultMessage: 'Was there any previous treatment for this condition?',
  },
  nameOfProvider: {
    id: 'fastCover.petMedicalStep.nameOfProvider',
    defaultMessage: 'Name Of Provider',
  },
  dateIncurred: {
    id: 'fastCover.petMedicalStep.dateIncurred',
    defaultMessage: 'Date Incurred',
  },
  amountOfBill: {
    id: 'fastCover.petMedicalStep.amountOfBill',
    defaultMessage: 'Amount Of Bill',
  },
  amountPaidByOtherInsurance: {
    id: 'fastCover.petMedicalStep.amountPaidByOtherInsurance',
    defaultMessage: 'Amount Paid by Other Insurance',
  },
  pleaseNoteTheirResponse: {
    id: 'fastCover.petMedicalStep.pleaseNoteTheirResponse',
    defaultMessage: 'Please Note Their Response',
  },
  whyNot: {
    id: 'fastCover.petMedicalStep.whyNot',
    defaultMessage: 'Why Not',
  },
  petName: {
    id: 'fastCover.petMedicalStep.petName',
    defaultMessage: 'Pet Name',
  },
  canineOrFeline: {
    id: 'fastCover.petMedicalStep.canineOrFeline',
    defaultMessage: 'Canine Or Feline',
  },
  petWeight: {
    id: 'fastCover.petMedicalStep.petWeight',
    defaultMessage: 'Pet Weight',
  },
  unit: {
    id: 'fastCover.petMedicalStep.unit',
    defaultMessage: 'Unit',
  },
  dateSicknessOrInjuryBegan: {
    id: 'fastCover.petMedicalStep.dateSicknessOrInjuryBegan',
    defaultMessage: 'Date Sickness or Injury began',
  },
  dateFirstTreated: {
    id: 'fastCover.petMedicalStep.dateFirstTreated',
    defaultMessage: 'Date First Treated',
  },
  canine: {
    id: 'fastCover.petMedicalStep.Canine',
    defaultMessage: 'Canine',
  },
  feline: {
    id: 'fastCover.petMedicalStep.Feline',
    defaultMessage: 'Feline',
  },
  natureOfInjury: {
    id: 'fastCover.petMedicalStep.natureOfInjury',
    defaultMessage: 'Nature Of Injury',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.PetMedicalStep/messages.js